// extracted by mini-css-extract-plugin
module.exports = {"more_text":"ClassTag_more_text__3WPWJ"};